import defaultParameters from 'models/parametersModel';
import { getFiltersInArray } from 'utils/arrayUtils';
import { v4 as uuidv4 } from 'uuid';

export const ACTION_TYPES = {
    SET_VEHICLE_DATA: 'setVehicleData',
    SET_ORIGINAL_FILTER_DATA: 'setVehicleFilterData',
    SET_OPEN_DROPDOWN: "setOpenDropdown",
    SET_FILTER_DATA: "setFilterData",
    SET_FILTER: "setFilter",
    SET_STATE_VALUES: 'setStateValues',
    SET_FILTER_SLIDER: 'setFilterSlider',
    SET_LOADING_VEHICLES: 'setLoadingVehicles',
    RESET_FILTERS_BY_SEARCH: 'resetFiltersBySearch',
};

const VehicleReducer = (state: any, action: any) => {
    switch (action.type) {
    case ACTION_TYPES.SET_VEHICLE_DATA: {
        return { ...state,
            vehicleResponse: action.payload,
            isLoadingVehicles: false,
            vehicleHash: uuidv4()
        };
    }
    case ACTION_TYPES.SET_ORIGINAL_FILTER_DATA: {
        let dataFiltersProcessed = [];
        if(action.runMethodPrepareFilter) 
        {
            dataFiltersProcessed = action.runMethodPrepareFilter(action.payload, action.filtersFromUrl);
        }
        return { 
            ...state,
            originalFilterData: action.payload,
            filtersData: dataFiltersProcessed,
            filtersHash: uuidv4(),
        };
    }
    case ACTION_TYPES.SET_FILTER: {
        const {
            payload: { filterName, values, filtersFromUrl, runMethodPrepareFilter },
        } = action;

        const filtersOverride =JSON.parse(JSON.stringify(filtersFromUrl));

        filtersOverride[filterName].values = values;

        const filtersFromUI = getFiltersInArray(filtersOverride);
        const lastElementOrderder = filtersFromUI
            .filter((c: any) => c.isFiltered)
            .sort((a: any, b: any) => b.orderFiltered - a.orderFiltered)?.[0];

        const lastOrder = lastElementOrderder?.orderFiltered ?? 0;

        if (values?.length > 0 && Number(filtersOverride[filterName].orderFiltered) === 0) 
        {
            filtersOverride[filterName].orderFiltered = lastOrder + 1;
            filtersOverride[filterName].isFiltered = true;
        } else if(values?.length === 0) {
            filtersOverride[filterName].orderFiltered = 0;
            filtersOverride[filterName].isFiltered = false;
        } else if (filtersOverride[filterName].orderFiltered > 0) {
            filtersOverride[filterName].isFiltered = true;
        }

        let dataFiltersProcessed = [];
        if(runMethodPrepareFilter) 
        {
            dataFiltersProcessed = runMethodPrepareFilter(state.originalFilterData, filtersOverride);
        }

        return {
            ...state,
            filtersData: dataFiltersProcessed,
            filtersHash: uuidv4(),
            currentPage: 0,
        };
    }
    case ACTION_TYPES.RESET_FILTERS_BY_SEARCH: {
        const {
            payload: { runMethodPrepareFilter },
        } = action;

        const initDefaultParams =JSON.parse(JSON.stringify(defaultParameters));

        let dataFiltersProcessed = [];
        if(runMethodPrepareFilter) 
        {
            dataFiltersProcessed = runMethodPrepareFilter(state.originalFilterData, initDefaultParams);
        }

        return {
            ...state,
            filtersData: dataFiltersProcessed,
            isLoadingVehicles: true,
            isloadingFilters: true,
            filtersHash: uuidv4(),
            currentPage: 0,
        };
    }
    case ACTION_TYPES.SET_FILTER_SLIDER: {
        const {
            payload: { filterName, values, filtersFromUrl, previousValues, runMethodPrepareFilter, valueReseted },
        } = action;

        const prevValues = previousValues?.keyName?.split('|');
        const prevValue1 = prevValues[0] ?? 0;
        const prevValue2 = prevValues[1] ?? 0;
        const newValue1 = values[0] ?? 0;
        const newValue2 = values[1] ?? 0;

        const valueChanged = prevValue1 !== newValue1 || prevValue2 !== newValue2;

        const filtersOverride =JSON.parse(JSON.stringify(filtersFromUrl));

        filtersOverride[filterName].values = values;

        const filtersFromUI = getFiltersInArray(filtersOverride);
        const lastElementOrderder = filtersFromUI
            .filter((c: any) => c.isFiltered)
            .sort((a: any, b: any) => b.orderFiltered - a.orderFiltered)?.[0];

        const lastOrder = lastElementOrderder?.orderFiltered ?? 0;

        if(valueReseted){
            filtersOverride[filterName].orderFiltered = 0;
            filtersOverride[filterName].isFiltered = false;
        } else if (valueChanged && Number(filtersOverride[filterName].orderFiltered) === 0) {
            filtersOverride[filterName].orderFiltered = lastOrder + 1;
            filtersOverride[filterName].isFiltered = true;
        } else if(filtersOverride[filterName].orderFiltered > 0){
            filtersOverride[filterName].isFiltered = true;
        }

        let dataFiltersProcessed = [];
        if(runMethodPrepareFilter) 
        {
            dataFiltersProcessed = runMethodPrepareFilter(state.originalFilterData, filtersOverride);
        }

        return {
            ...state,
            filtersData: dataFiltersProcessed,
            filtersHash: uuidv4(),
            currentPage: 0,
        };
    }
    case ACTION_TYPES.SET_OPEN_DROPDOWN: {
        const { filterName, val } = action.payload;

        const ddoinit = {
            style: false,
            make: false,
            model: false,
            transmission: false,
            lotname: false,
        };

        return {
            ...state,
            dropdownOpened: {
                ...ddoinit,
                [filterName]: val,
            },
        };
    }
    case ACTION_TYPES.SET_LOADING_VEHICLES: {
        return {
            ...state,
            isLoadingVehicles: action.payload.isLoadingVehicles,
        };
    }
    case ACTION_TYPES.SET_STATE_VALUES:{
        return {
            ...state,
            ...action.payload
        };
    }
    default:
        return state;
    }
};

export default VehicleReducer;
